export const openSeparateWindow = (): void => {
  const params = new URLSearchParams({ 'separate-window': 'true' });

  window.open(
    `/charts?${params.toString()}`,
    '_blank',
    'width=800,height=800,left=200,top=200,noopener,noreferrer,resizable,scrollbars',
  );
};
